import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { resetRestaurantDetails } from '@kfc-global/react-shared/redux/Actions/StoresAction';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const RestaurantMapView = (latLong, isMobile) => {
  const { RedMarker } = IMAGE_PATH;
  let googleMapRef = React.createRef();
  let googleMap;
  const dispatch = useDispatch();

  /* creating google map and set marker */
  const createGoogleMap = center => {
    const mapView =
      window.google &&
      new window.google.maps.Map(googleMapRef.current, {
        zoom: 10,
        center: center,
        disableDefaultUI: true,
        fullscreenControl: false,
        zoomControl: !isMobile,
        gestureHandling: 'greedy',
      });
    new window.google.maps.Marker({
      position: center,
      map: mapView,
      visible: true,
      icon: RedMarker,
    });
    return mapView;
  };

  useEffect(() => {
    return () => {
      dispatch(resetRestaurantDetails());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* creating a google map & marker instance by default passing latLong */
  useEffect(() => {
    const center = { lat: latLong?.latLong?.latitude, lng: latLong?.latLong?.longitude };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    googleMap = createGoogleMap(center);
  }, [window?.google]);

  return (
    <>
      <div id='google-map' className='rest-map-view' ref={googleMapRef}></div>
    </>
  );
};

const RestaurantMapViewViewSection = React.memo(RestaurantMapView);
export default RestaurantMapViewViewSection;
